export enum FileUploadAcceptType {
  //ALL_IMAGE_TYPES = 'image/*',
  JPG = '.jpg',
  PNG = '.png',
  JPEG = '.jpeg',
  PDF = '.pdf',
  APK = '.apk',
}
